import LocalTime from "local-time";
import { Controller } from "stimulus";
import StimulusReflex from "stimulus_reflex";

import { processAltitudeElements } from "../altitude";

export default class extends Controller {
  connect() {
    StimulusReflex.register(this);
  }

  reflexError(element, reflex, error) {
    window.alert(`Error invoking a Reflex! ${error}`);
  }

  noop(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  afterReflex() {
    LocalTime.getController().processElements();
    processAltitudeElements().catch(() => {});
  }
}
